
import { defineComponent } from "vue";
import { useRouter } from "vue-router";

// interfaces
import { IEmail } from "@/interfaces/email";

export default defineComponent({
  props: {
    data: {
      type: Array as () => IEmail[],
      required: true,
    },
    selectedTemplate: {
      type: String,
    },
    isAddable: {
      type: Boolean,
      default: false,
    },
    isEditable: {
      type: Boolean,
      default: false,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    defaultTemplateLoadingCount: {
      type: Number,
      default: 3,
    },
  },
  emits: ["setSelectedTemplate", "setDefaultTemplate", "deleteTemplate"],
  setup(props, { emit }) {
    const router = useRouter();

    const createAssessment = () => {
      router.push({
        name: "CustomizeEmailCreate",
      });
    };

    const selectAssessment = (id: string) => {
      emit("setSelectedTemplate", id);
    };

    const isAssessmentChosen = (id: string) => props.selectedTemplate === id;

    const editAssesment = (id: string) => {
      router.push({
        name: "CustomizeEmailEdit",
        params: {
          id,
        },
      });
    };

    const setDefaultAssesment = (id: string) => {
      emit("setDefaultTemplate", id);
    };

    const deleteAssesment = async (id: string) => {
      emit("deleteTemplate", id);
    };

    return {
      createAssessment,
      selectAssessment,
      isAssessmentChosen,
      setDefaultAssesment,
      editAssesment,
      deleteAssesment,
    };
  },
});
